<template>
  <div>
    <div v-html="html_footer04"></div>
    <div v-html="html_footer05"></div>
  </div>
</template>
<script>
export default {
  name: 'BottonCopyright',
  componentName: 'BottonCopyright',
  data () {
    return {
      footer_nav04_url: 'webpart/images_pc/footer_ft',
      html_footer04: '',
      footer_nav05_url: 'webpart/images_pc/footer_bd',
      html_footer05: ''
    }
  },
  created () {
    this.$myGet(this.footer_nav04_url)
      .then(res => {
        this.html_footer04 = res.response.data.imgUrls
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message)
      }),
      this.$myGet(this.footer_nav05_url)
        .then(res => {
          this.html_footer05 = res.response.data.imgUrls
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message)
        })
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/components/bottonCopyright.vue